module.exports = __webpack_public_path__ + "img/266261fdf70b3edd99e03680aed22271.svg";